import { MotionValue, animate } from "framer-motion";
import { useCallback, useState } from "react";
import { toast } from "sonner";

interface UseTapHandlerProps {
  x: MotionValue<number>;
  swiped: boolean;
  setSwiped: (value: boolean) => void;
  onAction: (direction: "left" | "right") => Promise<void>;
  getToastMessage: (direction: "left" | "right") => string;
}

export const useTapHandler = ({
  x,
  swiped,
  setSwiped,
  onAction,
  getToastMessage
}: UseTapHandlerProps) => {
  const [isProcessing, setIsProcessing] = useState(false);

  const handleTap = useCallback(
    async (direction: "left" | "right") => {
      if (isProcessing || swiped) return;

      setIsProcessing(true);

      try {
        // 現在の位置をリセット（念のため）
        x.set(0);

        // アニメーションを実行
        const targetX = direction === "right" ? 200 : -200;

        // スムーズなアニメーション（500ms）
        await animate(x, targetX, {
          duration: 0.5,
          ease: [0.25, 0.1, 0.25, 1] // easeOut
        });

        setSwiped(true);

        // コンポーネント固有のアクションを実行
        await onAction(direction);
        toast.success(getToastMessage(direction));
      } catch (error) {
        setSwiped(false);
        toast.error("エラーが発生しました");
        // エラー時は位置をリセット
        x.set(0);
      } finally {
        setIsProcessing(false);
      }
    },
    [x, swiped, setSwiped, onAction, getToastMessage, isProcessing]
  );

  return { handleTap, isProcessing };
};
